import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {usePaymentIntent} from '../hooks/usePaymentIntent';
import {PaymentIntent} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = usePaymentIntent();

    return (
        <FormDrawer
            record={{
                id: '',
                amount: 0,
                currency: 'usd',
                description: '',
                customerId: '',
                automaticPaymentMethods: {
                    enabled: true,
                },
                setupFutureUsage: 'offSession',
            } as PaymentIntent}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
